import { ProductKind, ProductKindType } from 'types/ProductKind'

export const AlwaysSelectedInstructionKinds = new Set<ProductKindType>([
  ProductKind.BILLING_ADDRESS,
  ProductKind.REFERENCE,
  ProductKind.PRODUCTION_COMMENTS,
])